<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>cloud_download</md-icon>
          </div>
          <md-toolbar class="fm-card-header">
            <h4 class="md-title">Client SDK Downloads</h4>
            <help-link :link="helpLink.link"></help-link>
          </md-toolbar>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100">
              <p>
                Click any of these links and download the Client SDK for the
                platform of your choice. Every download package comes with a
                complete working demo application to make getting started a
                breeze!
              </p>
            </div>
            <div class="md-layout-item md-size-66 md-small-size-100">
              <loading-spinner
                v-if="loadingStableSdk"
                title="latest SDK version"
                v-bind:loadingError="loadingStableSdkError"
              ></loading-spinner>
              <div class="md-layout" v-if="!loadingStableSdk">
                <div
                  class="md-layout-item md-size-50 md-small-size-100"
                  v-for="(download, i) in stableClientsSdks"
                  :key="i"
                >
                  <p
                    class="client-dl"
                    data-tour="download_links"
                  >
                    <a
                      :href="download.uri"
                      target="_blank"
                      @click="updateUser(download.platform)"
                      >{{ `LiveSwitch-${download.platform}-${download.version}.zip` }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-33 md-small-size-100">
              <br>
              <a @click="() => {this.deprecate_display = !this.deprecate_display}" id="deprecate_download">
                Looking for something else?
              </a>
              <p v-if="deprecate_display">
                These platforms have been deprecated and are no longer supported. They are made available to download here as needed, but they will no longer be updated in the future.
              </p>      
            </div>
            <div class="md-layout-item md-size-66 md-small-size-100" v-if="deprecate_display">
                <br>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-50 md-small-size-100"
                    v-for="(download, i) in deprecatedClientSdks"
                    :key="i"
                  >
                    <p
                      class="client-dl"
                      data-tour="download_links"
                    >
                      <a
                        :href="download.uri"
                        target="_blank"
                        @click="updateUser(download.platform)"
                        >{{ `LiveSwitch-${download.platform}-${download.version}.zip` }}</a
                      >
                    </p>
                  </div>
                </div>
              </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>cloud_download</md-icon>
          </div>
          <md-toolbar class="fm-card-header">
            <h4 class="md-title">Beta Client SDK Downloads</h4>
          </md-toolbar>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100">
              <p>
                Interested in checking out the latest features being worked on?
                Our beta track provides early access to the next minor release
                in active development. This is a great way to get a head start
                on your own development, but is not recommended for production
                environments.
              </p>
            </div>
            <div class="md-layout-item md-size-66 md-small-size-100">
              <div class="beta-loading-outer-container" v-if="loadingBetaSdk || !betaClientsSdks.length">
                <loading-spinner
                  v-if="loadingBetaSdk"
                  title="latest beta version"
                ></loading-spinner>
                <div class="sdk-loading-container">
                  <span
                    v-if="!loadingBetaSdk"
                    class="md-layout-item md-small-size-33 md-xsmall-size-100"
                    >No beta SDK available at this time. Check back later.</span
                  >
                </div>
              </div>
              <div class="md-layout" v-if="!loadingBetaSdk">
                <div
                  class="md-layout-item md-size-50 md-small-size-100"
                  v-for="(download, i) in betaClientsSdks"
                  :key="i"
                >
                  <p
                    class="client-dl"
                    data-tour="download_links"
                  >
                    <a
                      :href="download.uri"
                      target="_blank"
                      @click="updateUser(download.platform)"
                      >{{ `LiveSwitch-${download.platform}-${download.version}.zip` }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { getCurrentUser } from "../../utils/auth0";
import { appcuesIdentify } from "../../utils/appcues";
import api from "@/api";
import { HelpLinkTemplate, LoadingSpinner } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js'

const deprecatedSdks = new Set(["Uwp", "tvOS", "Java"]);

export default {
  components:{
    LoadingSpinner,
    'help-link': HelpLinkTemplate
  },
  mounted() {
    this.loadCurrentStable();
    this.loadCurrentBeta();
  },
  data: () => ({
    stableClientsSdks: [],
    deprecatedClientSdks: [],
    betaClientsSdks: [],
    hubspotPropertyMappings: [
      {
        platform: "Android",
        property: "lastLSCAndroidDownloadDate"
      },
      {
        platform: "Net",
        property: "lastLSCNetDownloadDate"
      },
      {
        platform: "Unity",
        property: "lastLSCUnityDownloadDate"
      },
      {
        plaftorm: "Hololens",
        property: "lastLSCHololensDownloadDate"
      },
      {
        platform: "Web",
        property: "lastLSCWebDownloadDate"
      },
      {
        platform: "iOS",
        property: "lastLSCIosDownloadDate"
      },
      {
        platform: "macOS",
        property: "lastLSCMacosDownloadDate"
      },
      {
        platform: "Xamarin",
        property: "lastLSCXamarinDownloadDate"
      }
    ],
    loadingStableSdk: true,
    loadingBetaSdk: true,
    loadingStableSdkError: false,
    helpLink: helpLinks.downloads,
    deprecate_display: false
  }),
  methods: {
    updateUser: function(platform) {
      var user = getCurrentUser();
      if (user !== undefined) {
        var hbProp = this.hubspotPropertyMappings.find(x => {
          return x.platform.toLowerCase() === platform.toLowerCase();
        });

        if (!hbProp) {
          return;
        }

        // Temporary while the Hololens example is included with the Unity download
        if (platform === "Unity") {
          user["lastLSCHololensDownloadDate"] = Date.now();
        }
        user[hbProp.property] = Date.now();
        appcuesIdentify(user.id, {
          // Unique identifier for current user
          LSC_LastAndroidDwnldDate: user.lastLSCAndroidDownloadDate,
          LSC_LastNetDwnldDate: user.lastLSCNetDownloadDate,
          LSC_LastUnityDwnldDate: user.lastLSCUnityDownloadDate,
          LSC_LastHololensDwnldDate: user.lastLSCHololensDownloadDate,
          LSC_LastWebDwnldDate: user.lastLSCWebDownloadDate,
          LSC_LastIosDwnldDate: user.lastLSCIosDownloadDate,
          LSC_LastMacosDwnldDate: user.lastLSCMacosDownloadDate,
          LSC_LastXamarinDwnldDate: user.lastLSCXamarinDownloadDate
        });
        this.$store.dispatch("user/updateEntity", user);
      }
    },
    loadCurrentStable() {
      api
        .getEntity(api.props.endPoints.latestStableSdk)
        .then(sdk => {
          sdk.forEach(item => {
            if (deprecatedSdks.has(item.platform)) {
              this.deprecatedClientSdks.push(item);
            } else {
              this.stableClientsSdks.push(item);
            }
          });

          this.loadingStableSdk = false;
        })
        .catch(ex => {
          console.log(ex);
          this.loadingStableSdkError = true;
        });
    },
    loadCurrentBeta() {
      api
        .getEntity(api.props.endPoints.latestBetaSdk)
        .then(sdk => {
          this.betaClientsSdks = sdk.filter(function(item) {
              return !deprecatedSdks.has(item.platform);
          });
        })
        .catch(ex => {
          console.log(ex);
        })
        .finally(() => {
          this.loadingBetaSdk = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.client-dl {
  margin: 10px 0;
}
.beta-loading-outer-container {
  height: 170px;
}
.sdk-loading-container {
  text-align: center;
  padding-top: 20px;
}
.sdk-error-text {
  color: red;
}
circle {
  stroke: green !important;
}
#deprecate_download:hover {
  cursor: pointer;
}
</style>
